"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFORMATION_KIND_DATA = exports.InformationKindUtil = exports.ExampleInformation = exports.PhraseInformation = exports.NormalInformation = exports.Information = void 0;
const object_1 = require("../util/object");
class Information {
    constructor(kind, date, hidden) {
        this.kind = kind;
        this.date = date;
        this.hidden = hidden;
    }
    getKindName(language) {
        return InformationKindUtil.getName(this.kind, language);
    }
}
exports.Information = Information;
class NormalInformation extends Information {
    constructor(kind, text, date, hidden) {
        super(kind, date, hidden);
        this.text = text;
    }
}
exports.NormalInformation = NormalInformation;
class PhraseInformation extends Information {
    constructor(expression, equivalentNames, text, date, hidden) {
        super("phrase", date, hidden);
        this.expression = expression;
        this.equivalentNames = equivalentNames;
        this.text = text;
    }
}
exports.PhraseInformation = PhraseInformation;
class ExampleInformation extends Information {
    constructor(sentence, translation, date, hidden) {
        super("example", date, hidden);
        this.sentence = sentence;
        this.translation = translation;
    }
}
exports.ExampleInformation = ExampleInformation;
class InformationKindUtil {
    static fromTag(tag) {
        const entry = object_1.ObjectUtil.entries(exports.INFORMATION_KIND_DATA).find(([kind, data]) => data.tag === tag);
        if (entry !== undefined) {
            return entry[0];
        }
        else {
            return undefined;
        }
    }
    static getTag(kind) {
        const tag = exports.INFORMATION_KIND_DATA[kind].tag;
        return tag;
    }
    static getName(kind, language) {
        const name = object_1.ObjectUtil.get(exports.INFORMATION_KIND_DATA[kind].names, language);
        return name;
    }
}
exports.InformationKindUtil = InformationKindUtil;
exports.INFORMATION_KIND_DATA = {
    meaning: { tag: "M", names: { ja: "語義", en: "Meaning" } },
    etymology: { tag: "E", names: { ja: "語源", en: "Etymology" } },
    usage: { tag: "U", names: { ja: "語法", en: "Usage" } },
    note: { tag: "N", names: { ja: "備考", en: "Note" } },
    task: { tag: "O", names: { ja: "タスク", en: "Task" } },
    history: { tag: "H", names: { ja: "履歴", en: "History" } },
    phrase: { tag: "P", names: { ja: "成句", en: "Phrase" } },
    example: { tag: "S", names: { ja: "例文", en: "Example" } }
};
